<template>
  <v-flex>{{pageTitle}} <span v-if="taskCount">({{taskCount}})</span></v-flex>
</template>

<script>
export default {
  name: "pageTitle",
  props: {
    pageTitle: String,
    taskCount: String
  }
}
</script>
